import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { connect } from "react-redux";
import MainWrapper from "../wrappers/MainWrapper";
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from "react-router-dom";
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import CustomTextField from "../../components/fields/CustomTextField";
import CheckboxGroup from "../../components/fields/CheckboxGroup";
import { reduxForm, Field, reset } from "redux-form";
import validateEmail from "../../utils/validateEmail";
import {   fetchAllCompany,createNewComp ,checkUserRole,editCompanyInfo} from "../../actions";
import Snackbar from '@material-ui/core/Snackbar';
import NotificationSnackBar from '../../utils/NotificationSnackBar';
import PlusCircleIcon from '@material-ui/icons/AddCircle';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import EnhancedTableToolbar from '../../utils/EnhancedTableToolbar';
import UserTable from '../../utils/MainTable/UserTable';
import { userListStyle } from '../../utils/Style';
import CompanyListTable from '../../utils/MainTable/CompanyListTable';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';

function getModalStyle() {
    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    };
}

const required_fields = [
    { name: "description", label: "description" },
    { name: "expiryDay", label: "expiry day" },
    { name: "type", label: "type" },
];

const WAIT_INTERVAL = 1000;

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    loadingHeight: {
        height: "100%",
        position: "fixed",
        top: "0",
        right: "0"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    button: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    alreadySignIn: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto"
    },
    success: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto",
        color: "green"
    }
});
function onlyUnique (value, index, self)  { 
    return self.indexOf(value) === index;
}

class NewCompany extends React.Component {
    

    constructor(props, context) {
        super(props, context);
        this.state = {
            selected: [],
            open: false,
            isSwitchSnackbarOn: false,
            phone:'',
            fax:'',
            newCompName:'',
            regNo:'',
            mailadd:'',
            page: 0,
            rowsPerPage: 5,
            offset: 0, 
            retrieveCompstatus:[], 
            uniqueGroup:[],
            addComp:null,
            companyName:'',
            selectedGroup:-1,
            retrieveComp:null,
            loading:false, 
            updatedData:[],  
            userRoles:{
                userRoles:[],
                error:null
            },
            newCompStat:{},
            edited:null,
        }; 
        this.props.fetchAllCompany(this.state.companyName); 
        this.props.checkUserRole();
    }
 
    componentDidMount(){ 
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today =yyyy + '-' +mm + '-' + dd ;
        this.setState({ loading: false,
            dateFrom: today,
            dateTo:today,
            retrieveCompstatus:[],
        }); 
    }
 
    handleUpdateCompanyInfo=()=>{   
        this.setState({ loading: true});
        var updated = this.state.updatedData; 
        this.props.editCompanyInfo(updated);
    }
     

    handleChange=(name)=>(event )=>{
        this.updateSnackbarStatusFalse();
        this.setState({[name]: event.target.value});
    }

    handleViewCompMap =(id) =>{
        this.props.ViewCompMap(id);
    }
    static getDerivedStateFromProps(props, state) {
        let update = {};
        if (props.retrieveCompstatus  !== state.retrieveCompstatus) {
            update.retrieveCompstatus =props.retrieveCompstatus;
            update.loading= false ;
        } 

        if(props.retrieveComp !== state.retrieveComp){
            let that = this;
            update.retrieveComp = props.retrieveComp;
            var onlyGroup = [];
            
            for(var i in props.retrieveComp.status){
                onlyGroup.push(props.retrieveComp.status[i].company_group)
            } 
            update.uniqueGroup =   onlyGroup.filter( onlyUnique );
            update.uniqueGroup.sort();
            update.loading = false; 
        }

        if (props.addComp  !== state.addComp) {
            update.addComp= props.addComp;
            
            update.isSnackbarError = props.addComp.isSnackbarError;
            update.isSwitchSnackbarOn =props.addComp.isSwitchSnackbarOn;
            update.snackbarErrorMessage =props.addComp.ErrorMessage; 
            update.loading=false;
        } 

        if(props.editCompany !== state.edited){
            update.edited = props.editCompany;
            update.loading=false;
            update.isSnackbarError = props.editCompany.isSnackbarError;
            update.isSwitchSnackbarOn =props.editCompany.isSwitchSnackbarOn;
            update.snackbarErrorMessage =props.editCompany.ErrorMessage; 
        }
          
        if(props.userRoles.success !== null)
        if(!props.userRoles.success){ 
            localStorage.clear(); 
            props.history.push("/signIn"); 
        }
        if(props.userRoles.userRoles.length !== state.userRoles.userRoles.length){ 
            if(props.userRoles.userRoles.length === 0){ 
            localStorage.clear(); 
            props.history.push("/signIn"); 
            }
        }

        return update; 
    }

    updateSnackbarStatus = (snackbarObject) => {
        this.setState({
            isSnackbarError: snackbarObject.isSnackbarError,
            isSwitchSnackbarOn: snackbarObject.isSwitchSnackbarOn,
            snackbarErrorMessage: snackbarObject.ErrorMessage
        })
    }

    updateSnackbarStatusFalse = () => {
        if (this.state.isSwitchSnackbarOn) {
            this.setState({ isSwitchSnackbarOn: false })
        }
    }
    
    /*
    _handleSubmit = values => {
        this.handleModalClose();
        Object.assign(values, { id: this.state.id }, { keyword: '' }, { offset: this.setNewOffset(this.state.rowsPerPage, this.state.page) }, { limit: this.state.rowsPerPage });
        this.props.registerPackage(values, this.props.history);
    };
    handleModalOpen = (id, username) => {
        this.updateSnackbarStatusFalse();
        this.setState({
            id: id,
            username: username,
            open: true,
        });
    };

    handleModalClose = () => {
        this.setState({ open: false });
        this.props.reset();
    }; 
    handleActive = () => {
        this.updateSnackbarStatusFalse();
        this.props.updateuserstoactive(this.state.selected, this.state.searchVal, this.setNewOffset(this.state.rowsPerPage, this.state.page), this.state.rowsPerPage);
    };

    handleInactive = () => {
        this.updateSnackbarStatusFalse();
        this.props.updateuserstoinactive(this.state.selected, this.state.searchVal, this.setNewOffset(this.state.rowsPerPage, this.state.page), this.state.rowsPerPage );
    };

    handleSelectAllClick = (event, checked) => {
        this.updateSnackbarStatusFalse();
        if (checked) {
            this.setState({ selected: this.state.users.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        this.updateSnackbarStatusFalse();
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.updateSnackbarStatusFalse();
        this.props.fetchUser(this.state.searchVal,this.setNewOffset(this.state.rowsPerPage, page), this.state.rowsPerPage);
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.updateSnackbarStatusFalse();
        this.props.fetchUser(this.state.searchVal,this.setNewOffset(event.target.value, this.state.page), event.target.value);
        this.setState({ rowsPerPage: event.target.value });
    };

    setNewOffset = (rowPerPage, page) => {
        return rowPerPage * page;
    }
*/
    handleSearch = event => {  
        this.setState({ loading: true, });  
        this.updateSnackbarStatusFalse();   
       // this.setState({ searchVal: event.target.value })
       this.props.fetchAllCompany(this.state.companyName); 
    };


    handleChangeCompany=event=>{
        this.setState({selectedGroup: event.target.value});
    }

    submitNewComp =()=>{
        var newComp={
            companyGroup:this.state.selectedGroup,
            companyName: this.state.newCompName,
            regNo :this.state.regNo,
            phone : this.state.phone,
            fax: this.state.fax,
            mailAddress: this.state.mailadd
        };

        this.setState({ loading: true }); 
        this.updateSnackbarStatusFalse(); 
        this.props.createNewComp(newComp);
    }

    
    handleEditedContent=(data)=>{ 
        this.setState({updatedData: data});
    }


    render() {

        const { classes } = this.props;
        const { users, order, orderBy, selected,uniqueGroup, rowsPerPage, page, offset, isSwitchSnackbarOn, isSnackbarError } = this.state;
       
        return (
            <MainWrapper
                history={this.props.history}
                isDisplayOn="none"
                userRoles={this.props.userRoles}>
          <Paper style={{marginTop:'10px',marginBottom:'10px'}}>
                <Grid container style={{padding:'10px'}}>
                <Grid container  >
                        <Grid item>
                        <EnhancedTableToolbar
                        tableName='Create New Company' numSelected={0}
                    />
                        </Grid>
                        
                        <Grid item>
                            
                        </Grid>
                    </Grid>
                    
                    <Grid container  style={{marginLeft:'50px'}}>
                        <Grid item xs={1}>
                           Company Group
                        </Grid>
                        
                        <Grid item style={{padding:'10px'}}>
                            
                            <FormControl className={classes.formControl}>
                                <InputLabel shrink htmlFor="company-label-placeholder">
                                Company Group
                                </InputLabel>
                                <Select
                                value={this.state.selectedGroup}
                                onChange={this.handleChangeCompany}
                                inputProps={{
                                    name: 'companygroup',
                                    id: 'company-label-placeholder',
                                }}
                                name="companygroup"
                                className={classes.selectEmpty}
                                >
                                    
                                {
                                 uniqueGroup.map(ei=>  
                                    <MenuItem  value={''+ei} key={ei}>{ei} </MenuItem>  
                                )}
                                </Select>
                                <FormHelperText>Company Group</FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container  style={{marginLeft:'50px'}}>
                        <Grid item xs={1}>
                            New Company Name
                        </Grid>
                        
                        <Grid item style={{padding:'10px'}}>
                            <TextField
                                    id="newCompName"
                                    label="New Company Name"
                                    onChange={ this.handleChange('newCompName')}
                                />
                        </Grid>
                    </Grid>
                    <Grid container  style={{marginTop:'10px',marginLeft:'50px'}}>
                        <Grid item xs={1}>
                            Registration No
                        </Grid>
                        
                        <Grid item style={{padding:'10px'}}>
                            <TextField
                                    id="regNo"
                                    label="Registration No"
                                    onChange={ this.handleChange('regNo')}
                                />
                        </Grid>
                    </Grid>
                    <Grid container  style={{marginTop:'10px',marginLeft:'50px'}}>
                        <Grid item xs={1}>
                            Phone
                        </Grid>
                        
                        <Grid item style={{padding:'10px'}}>
                            <TextField
                                    id="phone"
                                    label="phone"
                                    onChange={ this.handleChange('phone')}
                                />
                        </Grid>
                    </Grid>
                    <Grid container  style={{marginTop:'10px',marginLeft:'50px'}}>
                        <Grid item xs={1}>
                            Fax
                        </Grid>
                        
                        <Grid item style={{padding:'10px'}}>
                            <TextField
                                    id="fax"
                                    label="Fax"
                                    onChange={ this.handleChange('fax')}
                                />
                        </Grid>
                    </Grid>
                    <Grid container  style={{marginTop:'10px',marginLeft:'50px'}}>
                        <Grid item xs={1}>
                            Mail Address
                        </Grid>
                        
                        <Grid item style={{padding:'10px'}}>
                            <TextField
                                    id="mailadd"
                                    label="Mail Address"
                                    onChange={ this.handleChange('mailadd')}
                                />
                        </Grid>
                    </Grid>
                    <Grid container style={{marginTop:'10px',marginLeft:'50px'}}>
                        <Grid item xs={1}>
                          
                        </Grid>
                        
                        <Grid item style={{padding:'10px'}}>
                        <Button  variant="contained"
                color="primary" onClick={()=>this.submitNewComp()}>Save</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper> 

                <Paper className={classes.root}>
                    <EnhancedTableToolbar
                        tableName='Search Company' 
                        numSelected={0}
                    />
                    <div className={classes.search} style={{padding:'10px', paddingLeft:'20px'}}>
                        <Grid container spacing={8} alignItems="flex-end">
                            <Grid item>
                                <SearchIcon />
                            </Grid>
                            <Grid item>
                            <TextField
                                id="companyName"
                                label="Company Name"
                                defaultValue={this.state.companyName}
                                InputLabelProps={{
                                shrink: true,
                                }} 
                                onChange={this.handleChange('companyName')}
                            />
                            </Grid>
                            <Grid item>
                                <Button  variant="outlined"
                                onClick={(e) => this.handleSearch(e) } >Search</Button>
                            </Grid>
                            
                        </Grid>
                    </div>
                    <div className={classes.tableWrapper}>
                    <Grid container >
                            <Grid item xs={12}>
                                <CompanyListTable 
                                    data={this.state.retrieveCompstatus} 
                                    handleEditedContent={this.handleEditedContent}
                                />
                            </Grid> 
                            <Grid item xs={12}>
                                <Grid container justify='center' alignItems='center'>
                                    <Button
                                            className={classes.button}
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            disabled={this.state.isSwitchSnackbarOn}
                                            onClick={this.handleUpdateCompanyInfo}
                                        >
                                            Save Edited info
                                        </Button> 
                                   
                                </Grid>
                        
                            </Grid>
                        </Grid>
                    </div>
                    <NotificationSnackBar
                            isSwitchSnackbarOn={this.state.isSwitchSnackbarOn}
                            isSnackbarError={this.state.isSnackbarError}
                            snackbarErrorMessage={this.state.snackbarErrorMessage}
                    />
                </Paper> 
                {this.state.loading ? (
                <Grid container className={classes.root}>
                    <Grid item xs={12}>
                        <Grid container className={classes.loadingHeight} justify='center' alignItems='center'>
                        <div className="d-flex justify-content-center">
                            <CircularProgress color="primary" size={70} thickness={7} />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            ) : null
            }
            </MainWrapper>
        );
    }
}

NewCompany.propTypes = {
    classes: PropTypes.object.isRequired,
};

function validate(values) {
    const errors = {};

    
    return errors;
}

let SignInWithStyles = withStyles(styles)(NewCompany);

SignInWithStyles = reduxForm({ 
    form: "newCompForm"
})(SignInWithStyles);


  //    getNotExpiredPackages={this.props.notexpiredpackagesResult}>

const mapStateToProps = ({ editCompany, retrieveComp,userRoles }) => { 
    return { 
        editCompany:editCompany,
        userRoles: userRoles,
        retrieveCompstatus: retrieveComp.status,
        retrieveComp: retrieveComp,
        addComp: retrieveComp.addComp
    };
};

export default connect(
    mapStateToProps,
    { createNewComp, checkUserRole, fetchAllCompany,editCompanyInfo }
    
)(SignInWithStyles);




// WEBPACK FOOTER //
// ./src/components/tabs/NewCompany.js